import { AtsStaticTooltipParentRefEnum } from '@alliance/shared/utils'

const tooltip: Partial<Record<AtsStaticTooltipParentRefEnum, string>> = {
  [AtsStaticTooltipParentRefEnum.createProject]: 'З’явились нові вакансії? Створіть проєкт та збирайте відгуки в одному місці',
  [AtsStaticTooltipParentRefEnum.landingRedirectAnalytics]: 'Збираємо всі ваші дані по ефективності найму та джерел в розділ аналітики'
}

export default {
  projects: 'Проєкти',
  candidatesBase: 'База кандидатів',
  interviews: 'Зустрічі',
  analytics: 'Аналітика',
  createProject: 'Створити проєкт',
  login: 'Увійти',
  tooltip: { ...tooltip }
}
